// This file is AUTOGENERATED, do not edit it manually!!!

export const users = {
    active: 'Permitir',
    active_switch_description: 'Al establecer la propiedad Activa del usuario a desactivada, hace dos cosas: libera una licencia para otro usuario y hace que el usuario inactivo sea invisible en todas partes del sistema, excepto en la página Usuarios.',
    apply: 'Aplicar',
    assign: 'Agregar',
    assigned_activities_menu_title: 'Actividades asignadas',
    can_login: 'Puede iniciar sesión',
    can_login_switch_description: 'Al desactivar Puede iniciar sesión, solo niega el acceso del usuario al sistema. El usuario puede seguir siendo un miembro del proyecto o un cesionario. Esta acción también liberará una licencia si la necesita.',
    cancel: 'Cancelar',
    CanDenyLogin_User_DenyLoginYourself: 'No puede desactivar Puede iniciar sesión por sí mismo.',
    CanDenyLogin_User_LastAdministrator: 'No se puede desactivar el inicio de sesión único para un usuario que es el administrador único del sistema.',
    CanDisable_User_DisableYourself: 'No puede desactivar Active por sí mismo.',
    CanDisable_User_LastAdministrator: 'No puede desactivar Active para un usuario que es el administrador único del sistema.',
    cant_delete_user: 'No se pudo eliminar el usuario',
    cant_login: 'No se puede iniciar sesión',
    change_password: 'Cambiar contraseña',
    close: 'Cerrar',
    convert_title: 'Convertir',
    convert_to_regular: 'Convertir a usuario habitual',
    convert_to_regular_title: 'Conviértase {0} en un usuario habitual con el rol:',
    deactivate: 'Cambiar estado',
    deactivateTitle: 'Cambiar el estado del usuario a Inactivo',
    delete: 'Eliminar',
    delete_confirm: 'Eliminar este usuario?',
    delete_skill_title: 'Eliminar habilidad',
    delete_team_title: 'Eliminar equipo',
    DeleteRateBtnTitle: 'Eliminar Permanente',
    Disable_Permission_Message: 'Está a punto de deshabilitar un permiso en su rol que le permite editar sus propios permisos y los de otros usuarios.',
    Disable_Permission_Title: 'Ya no podrá editar los permisos de usuario.',
    DisplayName_customerId: 'Cliente',
    DisplayName_email: 'Correo electrónico',
    DisplayName_hourlyRate: 'Facturación tarifa por hora',
    DisplayName_login: 'Iniciar sesión',
    email: 'Correo electrónico',
    exclude: 'Excluir',
    filterbystatus_Active: 'Solo activo',
    filterbystatus_All: 'Activo e inactivo',
    filterbystatus_CannotLogin: 'Solo no se puede iniciar sesión',
    filterbystatus_Inactive: 'Solo inactivo',
    generate: 'Generar',
    guest_portal_title: 'Portal de Invitados.',
    guests_interaction: 'Los huéspedes solo pueden interactuar con el sistema a través de',
    guests_license: 'No requieren licencia.',
    guests_users_tab_title: 'Invitados',
    import_title: 'Importar',
    inactive: 'Inactivo',
    lastActivityDate_title: 'Última visita',
    licensing_limits_warning: 'No puede dar acceso a este usuario porque la licencia no permite agregar más usuarios que puedan iniciar sesión.',
    name_column_title: 'Nombre',
    no_sercurity_logs: 'Este usuario aún no tiene entradas',
    password_changed: 'La contraseña ha sido cambiada.',
    personal_schedule_title: 'Programación personal',
    regular_users_tab_title: 'Regular',
    reload: 'Actualizar',
    reset: 'Asignar',
    reset_password_confirmation: 'Al hacer clic en\" Generar\", se generará una nueva contraseña que se enviará por correo electrónico al usuario.',
    reset_password_done: 'Se ha generado y enviado una nueva contraseña.',
    reset_password_menu_title: 'Generar & enviar contraseña por correo electrónico',
    reset_password_title: 'Realmente desea generar y enviar por correo electrónico la nueva contraseña?',
    reset_permissions_confirmation: 'Para aplicar el rol actual ({0}) del usuario a todos los proyectos en los que el usuario es miembro, haga clic en Asignar. La operación no se puede deshacer. Para abortar, haga clic en Cancelar.',
    reset_permissions_done: 'Se asignó el rol actual.',
    reset_permissions_menu: 'Asignar el rol actual',
    reset_permissions_title: 'Realmente desea asignar el rol actual a todos los proyectos del usuario?',
    security_logs_action: 'Acción',
    security_logs_date: 'Fecha',
    security_logs_modal_title: 'Registro de seguridad para',
    security_logs_title: 'Registro de seguridad',
    securitylog_msg_GuestConverted: 'El rol cambió de Invitado a {0} invitado {1}.',
    securitylog_msg_LoginChanged: 'El inicio de sesión fue cambiado por el usuario {0}.',
    securitylog_msg_LoginChangedBySelf: 'Se ha cambiado el inicio de sesión.',
    securitylog_msg_PasswordChanged: 'La contraseña fue cambiada por el usuario {0}.',
    securitylog_msg_PasswordChangedByRecovery: 'Se recuperó la contraseña.',
    securitylog_msg_PasswordChangedBySelf: 'Se ha cambiado la contraseña.',
    securitylog_msg_PasswordGenerated: 'La contraseña fue generada por el usuario {0}.',
    securitylog_msg_PasswordGeneratedBySelf: 'Se generó la contraseña.',
    securitylog_msg_PasswordIncorrect: 'Contraseña incorrecta.',
    securitylog_msg_RecoveryRequest: 'Solicitud de recuperación.',
    securitylog_msg_RoleChanged: 'El rol cambió de {0} a {1} por {2}.',
    securitylog_msg_UserLockout: 'El usuario se bloqueó después de intentos de contraseña no válidos.',
    securitylog_msg_UserLockoutDueToInactivity: 'El usuario fue bloqueado debido a la inactividad.',
    securitylog_msg_UserUnlocked: 'El usuario fue desbloqueado por el usuario {0}.',
    selected_users: '1#{0} Usuario habitual seleccionado#{0} Usuarios habituales seleccionados',
    Set_teams: 'Equipos',
    show: 'Mostrar',
    show_other_reasons: 'Mostrar las otras razones',
    skills: 'Aptitudes',
    skills_updated_successfully: 'Las habilidades se han actualizado con éxito',
    skillsDeleteConfirm: 'La habilidad se eliminará de las habilidades de todos los usuarios',
    suggest_deactivate: 'Puede ocultar al usuario en cualquier lugar del {brandName} (excepto en la página Usuarios y en el historial de asignación de proyectos y tareas) cambiando su estado a Inactivo. De esta manera, puede liberar una licencia para otro usuario.',
    teams: 'Equipos',
    teams_updated_successfully: 'Los equipos se han actualizado correctamente',
    teamsDeleteConfirm: 'El equipo se eliminará de los equipos de todos los usuarios',
    TimerText: '1#{0}segundo#{0}segundos',
    unlock: 'Desbloquear',
    user_conversion_done: '{0} se ha convertido correctamente.',
    user_conversion_title: 'Conversión de usuarios',
    user_duplicate_email_error: 'Ya existe un usuario con el correo electrónico especificado',
    user_duplicate_login_error: 'Ya existe un usuario con el inicio de sesión especificado',
    user_licensing_limits_warning: 'No puede activar Puede iniciar sesión para este usuario, ya que no hay más plazas de licencia.',
    User_NotFound_Title: 'No Se Encontró El Usuario Solicitado',
    userRates: 'Historial de tarifas',
    userRates_date: 'Fecha de modificación',
    userRates_hourlyRate: 'Tasa de facturación',
    userRates_hourlyRateInternal: 'Tasa Interno',
    userRates_title: 'Tasa historial para {0}',
};
